declare global {
  interface Window {
    gtag: (
      command: "config" | "event",
      targetIdOrEventName: string,
      params?: Record<string, string | number | undefined>,
    ) => void;
  }
}

export const GA_TRACKING_ID = "G-G048FL5F3B";

export const pageview = (url: string) => {
  if (process.env.NODE_ENV === "production") {
    window.gtag("config", GA_TRACKING_ID, {
      page_path: url,
    });
  }
};

type GtagEventParams = {
  action: string;
  category?: string;
  label?: string;
  value?: number;
};

export const event = ({ action, category, label, value }: GtagEventParams) => {
  if (process.env.NODE_ENV === "production") {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value,
    });
  }
};
